import React, { useEffect, useState } from "react";
import { ToggleButtonGroup, styled } from "@mui/material";
import { subDays, subMonths, subWeeks, subYears } from "date-fns";
import { grayMed, grayscaleBg, grayscaleText } from "../../../../styles/theme";
import MuiToggleButton from "@mui/material/ToggleButton";
import { useConfig } from "../../../../context/ConfigContext";
import { isEqual } from "date-fns";

const ToggleButton = styled(MuiToggleButton)({
  backgroundColor: grayMed,
  color: grayscaleText,
  textTransform: "none",
  fontSize: "18px",
  padding: "8px 16px 10px 15px",
  height: "40px",
  border: "none",
  whiteSpace: "nowrap",
  borderRadius: " 4px !important",
  "&.Mui-selected, &.Mui-selected:hover, &:hover": {
    backgroundColor: grayscaleBg,
    color: grayscaleText,
  },
});

interface PresetOption {
  label: string;
  value: Date;
}

export const startOfDay = (date: Date) => {
  date.setHours(0, 0, 0, 0);
  return date;
};

const presetOptions: PresetOption[] = [
  { label: "today", value: new Date() },
  { label: "yesterday", value: subDays(new Date(), 1) },
  { label: "last week", value: subWeeks(new Date(), 1) },
  { label: "last month", value: subMonths(new Date(), 1) },
  { label: "last year", value: subYears(new Date(), 1) },
];
export interface PresetToggleGroupProps {}

const PresetToggleGroup: React.FunctionComponent<PresetToggleGroupProps> = ({}) => {
  const { startDate, setStartDate } = useConfig();
  const [alignment, setAlignment] = useState<PresetOption>(null);

  useEffect(() => {
    setAlignment(presetOptions.find((option) => isEqual(option.value, startDate)));
  }, [startDate]);

  const handleChange = (event: React.MouseEvent<HTMLElement>, optionSelected: PresetOption) => {
    if (!optionSelected) return;
    setStartDate(optionSelected.value);
    setAlignment(optionSelected);
  };

  return (
    <ToggleButtonGroup
      sx={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
      color="primary"
      value={alignment}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
    >
      {presetOptions.map((option) => (
        <ToggleButton key={option.label} value={option}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default PresetToggleGroup;
